import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {getITProcessById} from '../../../../../../../selectors/ISA315/selectors';
import BodySpecialAccordionHeaderColumn from '../BodySpecialAccordionHeaderColumn';
import {getItProcessApplicationCount} from './commonCounters';

function ItProcessItApplicationCount({itProcessId, header, className}) {
	const itProcess = useSelector((state) => getITProcessById(state, itProcessId));
	const relatedItApplications = useSelector((state) => state.bodiesSpecial.itApplications.byId);
	const relatedItAppCount = getItProcessApplicationCount(itProcess, relatedItApplications);
	return <StyledItProcessItAppCount className={className} header={header} value={relatedItAppCount || '-'} />;
}

ItProcessItApplicationCount.propTypes = {
	itProcessId: PropTypes.number.isRequired,
	header: PropTypes.string.isRequired,
	className: PropTypes.string
};

export default ItProcessItApplicationCount;

const StyledItProcessItAppCount = styled(BodySpecialAccordionHeaderColumn)`
	width: var(--px-100);
`;
